import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    vcpConfig: {},
    vcpConfigLoading: true,
    vcpConfigLoaded: false,
    currentTarget: 'p5',
    vcpHash: '',
  },
  actions,
  getters,
  mutations,
}
